export default __webpack_public_path__ + "static/media/acxiom.5298017f.png";